<button [type]="type" [disabled]="disabled" (click)="handleClick($event)" class="btn {{ btnClasses }}" [style]="styles">
  <ng-content></ng-content>
</button>
